import type { AvatarsPlacas } from '../modules/avatars/types/placa';
import { MACRO_AVATARS_PLACAS } from './MACRO/avatars/placas';

/**
 * Registry de placas de Avatars por cliente. Centralizado para que el editor
 * resuelva las placas sin saber qué clientes existen ni acoplarse a sus paths.
 *
 * Agregar un cliente nuevo:
 *   1. Crear `clients/<CLIENT_ID>/avatars/placas.ts` con la config tipada.
 *   2. Importar y sumar al `REGISTRY` debajo.
 */
const REGISTRY: Record<string, AvatarsPlacas> = {
  MACRO: MACRO_AVATARS_PLACAS,
  TEST: MACRO_AVATARS_PLACAS
};

export const getAvatarsPlacas = (clientId: string): AvatarsPlacas | undefined => REGISTRY[clientId];
